import CategoryButton from './CategoryButton.jsx';

export default CategoryButton;


// WEBPACK FOOTER //
// ./src/components/CategoryButton/index.jsx